import React from 'react';

import { Typography, Breadcrumbs, Box } from '@material-ui/core';

/*styles */

/*Components*/
import CancelTransactionForm from './Components/CancelTransactionForm.js';
import LegacyPageBanner from 'components/LegacyPageBanner';

import useStyles from './styles';

export default function Cancel(props) {
  const classes = useStyles();
  const pageTitle = 'Cancel TRNS';
  return (
    <React.Fragment>
      <div className={classes.pageContainer}>
        <Box>
          <Typography
            variant="h2"
            className={classes.textBold}
            align="left"
            gutterBottom={true}
          >
            {' '}
            {pageTitle}{' '}
          </Typography>
          <Breadcrumbs aria-label="breadcrumb">
            <span color="inherit">Transaction</span>
            <Typography color="primary">{pageTitle}</Typography>
          </Breadcrumbs>
        </Box>
        <LegacyPageBanner />
        <Box mt={2}>
          <CancelTransactionForm />
        </Box>
      </div>
    </React.Fragment>
  );
}
